export default __webpack_public_path__ + "static/media/automatemodularmanagement.57bbf6d5.svg";